import { clientId, lpRequest } from '../../../../core/api/lp-request';
import { getDeliveryPermissions } from './get-delivery-permissions';

export const addDeliveryPermission = async (
  driver_id: string,
  promisor_id: string,
  contract_id: string,
  hub_id: string
): Promise<any> => {
  await lpRequest(`/fleet/${clientId()}/drivers/${driver_id}/hubs`, {
    method: 'POST',
    body: { promisor_id, hub_id }
  });

  return getDeliveryPermissions(driver_id);
};
